import { render, staticRenderFns } from "./CommandesDetails.vue?vue&type=template&id=05f849ad&scoped=true"
import script from "./CommandesDetails.vue?vue&type=script&lang=js"
export * from "./CommandesDetails.vue?vue&type=script&lang=js"
import style0 from "./CommandesDetails.vue?vue&type=style&index=0&id=05f849ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f849ad",
  null
  
)

export default component.exports